import React from 'react';
import { Box } from '@chakra-ui/react';
import IntelliAssignTracker from './Intelliassign';
import './style.css'



function Mainindex() {

  return (
        <Box bg="#F4F7FD" >
         <IntelliAssignTracker/>
        </Box>
  
  );
}

export default Mainindex;